import {
  Component,
  Input,
  ContentChildren,
  QueryList,
  AfterContentInit,
  ChangeDetectionStrategy,
} from '@angular/core'

import { ButtonComponent } from '../button/button.component'

@Component({
  selector: 'hyperkit-button-group',
  standalone: true,
  imports: [],
  templateUrl: './button-group.component.html',
  styleUrls: ['./button-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonGroupComponent implements AfterContentInit {
  /** Selection behavior */
  @Input() selection: 'single' | 'multiple' = 'single'

  @ContentChildren(ButtonComponent)
  buttons!: QueryList<ButtonComponent>

  ngAfterContentInit(): void {
    this.buttons.forEach((button) => {
      const originalClick = button.handleClick.bind(button)

      button.handleClick = (event: MouseEvent) => {
        originalClick(event)
        this.handleSelection(button)
      }
    })
  }

  private handleSelection(clicked: ButtonComponent): void {
    if (this.selection === 'single') {
      this.buttons.forEach((btn) => {
        ;(btn as any).selected = btn === clicked
      })
    } else {
      ;(clicked as any).selected = !(clicked as any).selected
    }
  }
}
